export interface ISearchedUser{
    userId: number;
    displayName: string;
}